<template>
  <el-dialog
    v-dialogDrag
    :title="$t('importFromExcel')"
    :visible.sync="uploadFileProps.visible"
    :close-on-click-modal="false"
    width="760px"
    class="small-dialog"
    append-to-body
  >
    <el-steps
      finish-status="success"
      :active="uploadFileProps.active"
      class="mt-20px"
      align-center
    >
      <el-step
        class="text-14px"
        :title="$t('downloadTheTemplate')"
        @click="downloadTemplate"
      ></el-step>
      <el-step :title="$t('uploadTheFile')"></el-step>
      <el-step :title="$t('finish')"></el-step>
    </el-steps>
    <div
      v-if="uploadFileProps.active === 0"
      v-loading="uploadFileProps.templateLoading"
    >
      <div class="text-center mt-76px">
        <div class="upload-demo">
          <div
            class="el-upload el-upload--text down-text border border-dashed border-neutral-300 rounded w-490px h-244px"
          >
            <div class="mt-70px">
              <i
                @click="downloadTemplate"
                class="icon iconfont icon-bg-excel h-full text-50px blue-700 text-color-system"
              ></i>
              <!-- text-blue-500 -->
              <div class="el-upload__text mt-10px">
                {{ $t('clickTheIconToDownloadTheTemplateFill') }}
                <em class="text-color text-color-system" @click="nextStep">
                  {{ $t('next') }}</em
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="uploadFileProps.active === 1"
      class="text-center mt-76px mb-4px"
    >
      <el-upload
        v-loading="uploadFileProps.btnLoading"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
        class="dialog__upload"
      >
        <i
          class="el-icon-upload text-67px blue-700 text-color-system !mt-70px"
        ></i>
        <div class="el-upload__text">
          {{ $t('uploadTheFileTwo') }}
          <em> {{ $t('clickUpload') }}</em>
        </div>
      </el-upload>
    </div>
    <div class="padding-1" v-show="uploadFileProps.active === 2">
      <div class="text-center mt-76px">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="mt-25px pt-20px">
              <div
                class="mt-30px flex items-center"
                v-if="
                  uploadFileProps.resultFile !== undefined &&
                  uploadFileProps.resultFile !== ''
                "
              >
                <i
                  class="iconfont icon-line-complete text-24px text-green-500"
                ></i>
                <span class="text-20px ml-10px mr-10px">
                  {{
                    `${$t('theUploadIsSuccessful')}！${$t('success')}${
                      uploadFileProps.successCount
                    }${$t('items')}，${$t('failed')}${
                      uploadFileProps.failureCount
                    }${$t('items')}`
                  }}
                </span>
                <el-button size="mini" type="primary" @click="exportResults">{{
                  $t('downloadTheResults')
                }}</el-button>
              </div>
              <div
                class="el-upload__text"
                v-else-if="
                  uploadFileProps.resultFile === undefined ||
                  uploadFileProps.resultFile === ''
                "
              >
                <div class="mt-25px pt-20px">
                  <span class="mt-30px">
                    <i
                      class="iconfont icon-line-complete text-54px text-green-500"
                    ></i>
                  </span>
                  <div class="el-upload__text">
                    {{ $t('theUploadIsSuccessful') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="text-center">
      <el-button
        v-if="uploadFileProps.active === 1"
        type="primary"
        size="small"
        @click="uploadFileProps.active = 0"
        :loading="uploadFileProps.btnLoading"
      >
        {{ $t('previousStep') }}</el-button
      >
      <el-button
        v-if="uploadFileProps.active === 2"
        type="primary"
        size="small"
        @click="closeDialog"
        :loading="uploadFileProps.btnLoading"
        >{{ $t('finish') }}</el-button
      >
      <el-button
        v-if="uploadFileProps.active === 0"
        type="primary"
        size="small"
        @click="nextStep"
        :loading="uploadFileProps.btnLoading"
        >{{ $t('next') }}</el-button
      >
      <el-button
        @click="uploadFileProps.active = 1"
        v-if="uploadFileProps.active === 2"
        size="small"
        >{{ $t('previousStep') }}</el-button
      >
      <el-button
        @click="closeDialog"
        v-if="uploadFileProps.active !== 2"
        size="small"
        :loading="uploadFileProps.btnLoading"
      >
        {{ $t('cancel') }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'wiz-upload-file',

  props: {
    /**
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    uploadFileProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
          active: 1,
          btnLoading: false,
          isTestAndVerify: false,
          type: [],
          templateLoading: false,
          maxSize: null,
        }
      },
    },
  },
  data() {
    return {
      file: '',
      suffix: false,
    }
  },
  watch: {},
  methods: {
    // 下载模板
    async downloadTemplate() {
      this.$emit('exportTemplate')
    },
    // 下一步
    nextStep() {
      this.uploadFileProps.active += 1
      if (this.uploadFileProps.active > 2) {
        this.uploadFileProps.active = 1
      }
    },
    // 获取上传的内容并校验格式
    getFileContent(file) {
      this.file = file
      if (this.uploadFileProps.isTestAndVerify) {
        const format = file.name.substring(file.name.lastIndexOf('.') + 1)
        this.uploadFileProps.type.forEach((item) => {
          if (format === item) {
            this.suffix = true
          }
        })
        if (!this.suffix) {
          this.$message.error(
            `${this.$t(
              'fileFormatError'
            )}${this.uploadFileProps.type.join()}${this.$t('file')}`
          )
          return false
        }
      }
      if (this.uploadFileProps.maxSize && this.uploadFileProps.maxSize > 0) {
        const isLimitSize =
          file.size / 1024 / 1024 < this.uploadFileProps.maxSize
        if (!isLimitSize) {
          this.$message.error(
            `${this.$t('fileSizeMax')} ${this.uploadFileProps.maxSize}MB!`
          )
          return false
        }
      }
      return this.suffix
    },
    // 上传
    async uploadExcel() {
      if (this.suffix) {
        this.$emit('importTemplate', this.file)
      }
    },
    exportResults() {
      this.$emit('exportResults')
    },
    // 关闭弹窗并重新请求列表
    closeDialog() {
      this.$emit('refreshList')
      this.uploadFileProps.active = 1
      this.file = ''
      this.uploadFileProps.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
.dialog__upload {
  ::v-deep .el-step.is-simple {
    .el-step__title {
      font-size: 15px !important;
    }
  }
  ::v-deep .el-upload-dragger {
    height: 244px !important;
    width: 490px !important;
  }
}
</style>
